import {useState, useEffect} from 'react';

const useResizeObserver = (ref, depedencies) => {
  const [dimensions, setDimensions] = useState({
    bottom: null,
    height: null,
    left: null,
    right: null,
    top: null,
    width: null, 
    x: null,
    y: null,
  });
  
  const observe = ({contentRect}) => setDimensions(contentRect);

  useEffect(
    () => {
      const resizeObserver = new ResizeObserver(([entry]) => observe(entry));
      resizeObserver.observe(ref.current);
      return () => resizeObserver.disconnect();
    },
    depedencies
  );

  return dimensions;
};

export default useResizeObserver;